export enum MouseButton {
  Main,
  Auxiliary,
  Secondary,
  Fourth,
  Fifth
}
